
const claimManagementStyles = {
    cellStyle: {
        background: "#fafafa",
        border: "1px solid #ccc",
        borderLeft: "2px solid #ccc",
        boxShadow: "2px 0 4px rgba(0,0,0,0.05)",
        padding: "6px 8px",
        fontWeight: "400",
        height: "28px",
        lineHeight: "2.8",
        verticalAlign: "middle",
        textAlign: "center",
    },

    tableHeadStyle: {
        background: "#03a9f4",
        color: "#ffffff",
        border: "1px solid #ccc",
        borderLeft: "2px solid #ccc",
        boxShadow: "2px 0 4px rgba(0,0,0,0.08)",
        padding: "12px",
        minWidth: "150px",
        height: "35px",
        fontWeight: "450",
    },
};
export default claimManagementStyles;
